import { MDBIcon, MDBInput, MDBDataTable } from 'mdbreact';
import React, { Component } from 'react';
import { CargueImagenes, PreguntasFrecuentesLista_ } from '../../../services/WebAPI_Utrahuilca';
import FileUploader from './Preguntas/FileUploader';
import Swal from 'sweetalert2';
import { URLImgFront } from '../../../config/URLDB';

const validate = values => {
    const errors = {}
    if (values.prioridad === 'DEFAULT') {
        errors.prioridad = 'campo obligatorio'
    }
    if (!values.titulopreg) {
        errors.titulopreg = 'campo obligatorio'
    }
    if (!values.descpregfrec1) {
        errors.descpregfrec1 = 'campo obligatorio'
    }
    
    return errors;
};

class Preguntas extends Component {
    //RQTO. CDAT Y AHORRO DIGITAL, REAJUSTE YC
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            estadoSinInfo: false,
            infoConveniosDetalles: [],
            idpregfrecuente: null,
            rutaiconpreg: '',
            prioridad: 'DEFAULT',
            titulopreg: '',
            descpregfrec1: '',
            descpregfrec2: '',
            descpregfrec3: '',
            descpregfrec4: '',
            editprioridad: 'DEFAULT',
            edittitulopreg: '',
            editdescpregfrec1: '',
            editdescpregfrec2: '',
            editdescpregfrec3: '',
            editdescpregfrec4: '',
            estadoCambio: true,
            estado: null,
            boolprioridad: false,
            nombreboton: 'Guardar'
        };
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idpregfrecuente: 0,
            rutaiconpreg: 'NA',
            prioridad: 0,
            titulopreg: 'NA',
            descpregfrec1: 'NA',
            descpregfrec2: 'NA',
            descpregfrec3: 'NA',
            descpregfrec4: 'NA',
            estado: 0
        }
        PreguntasFrecuentesLista_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (!response.data[0].message) {
                        this.setState({
                            idSeleccionado: response.data[0].idpregfrecuente
                        })
                        setTimeout(() => {
                            this.setState({
                                infoConveniosDetalles: response.data,
                                rutaiconpreg: response.data[0].rutaiconpreg,
                                estado: response.data[0].estado,
                                estadoSinInfo: true,
                                estadoImagen: true,
                            })
                        }, 120);
                    } else {
                        this.setState({
                            estadoSinResultados: false,
                            estadoNuevo: true,
                            estadoCambioImg1: true,
                            estadoSinInfo: false
                        })
                    }
                } else { }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio!'
                })
            }
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cambio = (name, file) => {
        this.setState({
            estadoCambio: true
        });
    }

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Preguntas Frecuentes/Preguntas/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    TransarDatos = (id) => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });

        if (!Object.keys(result).length)
        {
            let letidpregfrecuente = 0;
            var ruta = '';

            if (id == null) {
                letidpregfrecuente = 0;
                ruta = '/Preguntas Frecuentes/Preguntas/' + this.uploader.current.getFileName();
            }
            else {
                letidpregfrecuente = id.idpregfrecuente;
                var capNombre = this.uploader.current.getFileName();

                if (capNombre == undefined || capNombre == null) {
                    ruta = this.state.rutaiconpreg;
                } else {
                    ruta = '/Preguntas Frecuentes/Preguntas/' + this.uploader.current.getFileName();
                }
            }

            //FORMULARIO VALIDADO
            const data = {
                tran: 1,
                idpregfrecuente: letidpregfrecuente,
                rutaiconpreg: ruta,
                prioridad: parseInt(this.state.prioridad),
                titulopreg: this.state.titulopreg,
                descpregfrec1: this.state.descpregfrec1,
                descpregfrec2: this.state.descpregfrec2 == null || this.state.descpregfrec2 == '' ? '' : this.state.descpregfrec2,
                descpregfrec3: this.state.descpregfrec3 == null || this.state.descpregfrec3 == '' ? '' : this.state.descpregfrec3,
                descpregfrec4: this.state.descpregfrec4 == null || this.state.descpregfrec4 == '' ? '' : this.state.descpregfrec4,
                estado: 1
            }
            PreguntasFrecuentesLista_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: id == null ? 'Se agrego correctamente.' : 'Se actualizo satisfactoriamente'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: id == null ? 'Error al insertar.' : 'Ocurrio un error al actualizar'
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    });
                }

                //AQUI LIMPIO LA INFORMACIÓN
                this.limpiarInformacionFormulario();

                //AQUI CARGO LA INFOMACIÓN
                this.cargarInformacion();
            });
        }
    }

    editar = (id) => {
        var seleccionado = [];
        this.state.infoConveniosDetalles.map((e) => {
            if (e.idpregfrecuente === id) {
                seleccionado.push(e)
            }
            return [];
        })
        this.setState({
            idpregfrecuente: seleccionado[0].idpregfrecuente,
            edittitulopreg: seleccionado[0].titulopreg,
            editdescpregfrec1: seleccionado[0].descpregfrec1,
            editdescpregfrec2: seleccionado[0].descpregfrec2,
            editdescpregfrec3: seleccionado[0].descpregfrec3,
            editdescpregfrec4: seleccionado[0].descpregfrec4,
            rutaiconpreg: seleccionado[0].rutaiconpreg,
            editprioridad: seleccionado[0].prioridad,
            estadoEditar: true
        })
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idpregfrecuente: id,
            rutaiconpreg: 'NA',
            prioridad: 0,
            titulopreg: 'NA',
            descpregfrec1: 'NA',
            descpregfrec2: 'NA',
            descpregfrec3: 'NA',
            descpregfrec4: 'NA',
            estado: 1
        }

        PreguntasFrecuentesLista_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    inactivar = (id) => {
        const data = {
            tran: 6,
            idpregfrecuente: id,
            rutaiconpreg: 'NA',
            prioridad: 0,
            titulopreg: 'NA',
            descpregfrec1: 'NA',
            descpregfrec2: 'NA',
            descpregfrec3: 'NA',
            descpregfrec4: 'NA',
            estado: 0
        }
        PreguntasFrecuentesLista_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se inactivo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    limpiarInformacionFormulario = () => {
        this.setState({
            estadoNuevo: false,
            registroSeleccionado: null,
            prioridad: 'DEFAULT',
            titulopreg: '',
            descpregfrec1: '',
            descpregfrec2: '',
            descpregfrec3: '',
            descpregfrec4: '',
            boolprioridad: false,
            nombreboton: 'Guardar',
            rutaiconpreg: '',
            estadoCambio: true,
            errors: {}
        });
    }

    handleNew = (registro) => {
        //AQUI LIMPIO LA INFORMACIÓN
        this.limpiarInformacionFormulario();

        this.setState({ estadoNuevo: !this.state.estadoNuevo, });

        if (registro == null) {
            if (this.state.estadoNuevo) {
                this.cargarInformacion();
            }
        }
        else {
            this.setState({
                registroSeleccionado: registro,
                prioridad: registro.prioridad,
                titulopreg: registro.titulopreg,
                descpregfrec1: registro.descpregfrec1,
                descpregfrec2: registro.descpregfrec2 == null || registro.descpregfrec2 == '' ? '' : registro.descpregfrec2,
                descpregfrec3: registro.descpregfrec3 == null || registro.descpregfrec3 == '' ? '' : registro.descpregfrec3,
                descpregfrec4: registro.descpregfrec4 == null || registro.descpregfrec4 == '' ? '' : registro.descpregfrec4,
                editprioridad: registro.prioridad,
                rutaiconpreg: registro.rutaiconpreg,
                nombreboton: 'Editar',
                estadoCambio: false
            });
        }
    }

    render() {
        const { estadoNuevo, estadoSinInfo, errors, infoConveniosDetalles } = this.state;
        return (
            <React.Fragment>
                <p className="font-weight-bold">Preguntas</p>
                <hr />
                {estadoSinInfo ? (
                    <React.Fragment>
                        <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew(null) }}>
                            {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 my-2 text-center">
                                    <FileUploader ref={this.uploader} estadoImg={this.state.estadoCambio} ruta={this.state.rutaiconpreg} FCambiar={this.cambio} />
                                    {/*<FileUploader ref={this.uploader} estadoImg={this.state.estadoImg} ruta={this.state.rutaiconpreg} FCambiar={this.cambio} />*/}
                                </div>
                                <div className="col-md-12 my-2">
                                    <label>Tipo de Pregunta/Ubicación</label>
                                    <select name="prioridad" className="form-control" value={this.state.prioridad} disabled={this.state.boolprioridad} onChange={this.textInput} >
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="0">Pregunta Principal</option>
                                        <option value="1">Más preguntas</option>
                                    </select>
                                    {errors.prioridad && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.prioridad}</strong>}
                                </div>
                                <div className="col-md-12 my-2">
                                    <MDBInput label="Titulo Pregunta" name="titulopreg" type="text" value={this.state.titulopreg} onChange={this.textInput} />
                                    {errors.titulopreg && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.titulopreg}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <MDBInput label="Descripción 1" name="descpregfrec1" type="textarea" rows="5" value={this.state.descpregfrec1} onChange={this.textInput} />
                                    {errors.descpregfrec1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-30px' }}>{errors.descpregfrec1}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <MDBInput label="Descripción 2" name="descpregfrec2" type="textarea" rows="5" value={this.state.descpregfrec2} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6 my-2">
                                    <MDBInput label="Descripción 3" name="descpregfrec3" type="textarea" rows="3" value={this.state.descpregfrec3} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6 my-2">
                                    <MDBInput label="Descripción 4" name="descpregfrec4" type="textarea" rows="3" value={this.state.descpregfrec4} onChange={this.textInput} />
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={() => this.TransarDatos(this.state.registroSeleccionado)}>{this.state.nombreboton} Producto &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <MDBDataTable
                            striped
                            bordered
                            hover
                            data={{
                                columns: [
                                    { label: 'Imagen', field: 'imagen' },
                                    { label: 'Prioridad Posición', field: 'prioridad' },
                                    { label: 'Titulo Pregunta', field: 'titulopreg' },
                                    { label: 'Descripción 1', field: 'desc1' },
                                    { label: 'Descripción 2', field: 'desc2' },
                                    { label: 'Descripción 3', field: 'desc3' },
                                    { label: 'Descripción 4', field: 'desc4' },
                                    { label: 'Editar', field: 'editar' },
                                    { label: 'Inactivar', field: 'inactivar' },
                                ],
                                rows: infoConveniosDetalles.map((e) => {
                                    const tipoPrioridad = e.prioridad === 1 ? 'Inferior' : 'Superior';
                                    const icono = e.estado === 1
                                        ? <MDBIcon icon="eye" size="2x" style={{ cursor: 'pointer' }} onClick={() => this.inactivar(e.idpregfrecuente)} />
                                        : <MDBIcon icon="eye-slash" size="2x" style={{ cursor: 'pointer' }} onClick={() => this.activar(e.idpregfrecuente)} />;

                                    return {
                                        imagen: <img className="img-fluid" style={{ width: '75px' }} src={`${URLImgFront}/assets${e.rutaiconpreg}`} alt={e.rutaiconpreg} />,
                                        prioridad: tipoPrioridad,
                                        titulopreg: e.titulopreg,
                                        desc1: e.descpregfrec1,
                                        desc2: e.descpregfrec2,
                                        desc3: e.descpregfrec3,
                                        desc4: e.descpregfrec4,
                                        editar: (
                                            <MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }}
                                                onClick={() => this.handleNew(e)} />
                                        ),
                                        inactivar: icono
                                    };
                                })
                            }}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default Preguntas;